<ng-container *ngIf="mostraFiltroDisponibilita">



    <ng-container *ngIf="!mostraCaricamentoDisponibilitaUVM">

        <div>
            <strong>1 - Elenco operatori disponibili</strong>
            <div>
                <mat-form-field>
                    <mat-label>Cerca operatori</mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>

                <table mat-table [dataSource]="dataSource">



                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Nome </th>
                        <td mat-cell *matCellDef="let element"> {{element.nome}}</td>
                    </ng-container>

                    <ng-container matColumnDef="Cognome">
                        <th mat-header-cell *matHeaderCellDef> Cognome </th>
                        <td mat-cell *matCellDef="let element"> {{element.cognome}}</td>
                    </ng-container>

                    <ng-container matColumnDef="Qualifica">
                        <th mat-header-cell *matHeaderCellDef> Qualifica</th>
                        <td mat-cell *matCellDef="let element"> {{element.qualifica}}</td>
                    </ng-container>


                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> <button mat-button (click)="addToSelected(element)"
                                *ngIf="this.mostraAggiungi"><mat-icon aria-hidden="false" aria-label="Aggiungi icona"
                                    fontIcon="add"></mat-icon> Aggiungi</button> </td>
                    </ng-container>


                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="4">Nessun dato trovato per "{{input.value}}"</td>
                    </tr>


                </table>

                <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
                    aria-label="Select page of periodic elements">
                </mat-paginator>
            </div>
        </div>

        <div>
            <strong>2 - Operatore selezionato</strong>
            <button mat-button (click)="svuotaListaOperatori()"><mat-icon aria-hidden="false"
                    aria-label="Aggiungi icona" fontIcon="cancel"></mat-icon>Svuota lista</button>
            <table mat-table [dataSource]="dataSoruceSelected">



                <ng-container matColumnDef="Nome">
                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                    <td mat-cell *matCellDef="let element"> {{element.nome}}</td>
                </ng-container>

                <ng-container matColumnDef="Cognome">
                    <th mat-header-cell *matHeaderCellDef> Cognome </th>
                    <td mat-cell *matCellDef="let element"> {{element.cognome}}</td>
                </ng-container>

                <ng-container matColumnDef="Qualifica">
                    <th mat-header-cell *matHeaderCellDef> Qualifica</th>
                    <td mat-cell *matCellDef="let element"> {{element.qualifica}}</td>
                </ng-container>


                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef> </th>
                    <td mat-cell *matCellDef="let element"> <button mat-button
                            (click)="rimuoviDaListaOperatoriSelezionate(element)"><mat-icon aria-hidden="false"
                                aria-label="Aggiungi icona" fontIcon="delete"></mat-icon> Rimuovi</button> </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <tr class="mat-row " *matNoDataRow>
                    <td class="mat-cell no-results-row" [attr.colspan]="displayedColumns.length">
                        <div class="alert alert-warning " role="alert">
                            Nessun operatore selezionato.
                        </div>
                    </td>
                </tr>


            </table>


        </div>

    </ng-container>


    <button mat-flat-button (click)="saveOperatori()" class="mt-4" [disabled]="this.mostraAggiungi">
        <mat-icon>arrow_forward</mat-icon>Avanti
    </button>

</ng-container>